export { default } from './Tabs';
export { default as TabPanel } from './TabPanel';
export { default as TabsContext } from './TabsContext';
export type { TabsProps, Tab } from './Tabs.types';
